import React from 'react'
import { useField } from '@formiz/core'

export const Field = (props) => {
  const {
    errorMessage,
    id,
    isValid,
    isPristine, 
    isSubmitted,
    resetKey,
    setValue,
    value,
  } = useField(props)
  const { label, type, required, placeholder, maxLength } = props
  const [isFocused, setIsFocused] = React.useState(false);
  const showError = !isValid && !isFocused && (!isPristine || isSubmitted)

  return (
    <div>
      <label
        className=""
        htmlFor={id}
      >
        { label }
        {required && ' *'}
      </label>
      <input
        key={resetKey}
        id={id}
        type={type || 'text'}
        value={value || ''}
        placeholder = {placeholder}
        maxlength={maxLength || 9999}
        className={`${showError ? 'is-error form-control' : 'form-control'}`}
        onChange={e => setValue(e.target.value)}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        aria-invalid={!isValid}
        aria-describedby={!isValid ? `${id}-error` : null}
      />
      {showError && (
        <div id={`${id}-error`} className="error-feedback">
          { errorMessage }
        </div>
      )}
    </div>
  )
}